<div class="error-summary-wrapper" *ngIf="errors.length">
	<h2 class="linq-header">{{ headerText }}</h2>
	<ul>
		<li *ngFor="let error of errors">{{ error }}</li>
	</ul>
</div>
